import React from "react";
import { Star, Lightning } from "@phosphor-icons/react";

/**
 * Grilla de comidas frecuentes del atleta.
 * - Muestra top N con imagen, nombre, marca y kcal por porción sugerida.
 * - Click = quick-add al día actual (un solo toque).
 */
export default function FrequentFoods({ items, onQuickAdd, loading }) {
  if (loading) {
    return (
      <div className="card-base p-6" data-testid="frequent-foods-loading">
        <div className="text-xs uppercase tracking-widest text-muted">Cargando tus favoritos...</div>
      </div>
    );
  }
  if (!items || items.length === 0) return null;

  return (
    <div className="card-base p-5 sm:p-6" data-testid="frequent-foods">
      <div className="flex items-center gap-2 mb-4">
        <Star size={18} weight="fill" className="text-[#FFD60A]" />
        <h3 className="font-display font-black uppercase text-xl tracking-tighter">Tus favoritos</h3>
        <span className="text-[10px] uppercase tracking-widest text-muted ml-1">un toque para agregar</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {items.map((f) => {
          const hintG = f.serving_hint_g || f.serving_size_g || 100;
          const factor = hintG / (f.serving_size_g || 100);
          const kcalHint = Math.round((f.calories || 0) * factor);
          return (
            <button
              key={f.food_id}
              type="button"
              onClick={() => onQuickAdd?.(f)}
              className="card-base !p-3 text-left group hover:!border-[#FFD60A] transition-colors relative overflow-hidden"
              data-testid={`fav-${f.food_id}`}
            >
              {f.image_url ? (
                <div className="w-full h-20 mb-2 bg-white overflow-hidden">
                  <img src={f.image_url} alt="" className="w-full h-full object-contain" loading="lazy" />
                </div>
              ) : (
                <div className="w-full h-20 mb-2 bg-[#141414] flex items-center justify-center border border-app">
                  <Lightning size={24} weight="duotone" className="text-[#262626]" />
                </div>
              )}
              <div className="font-display font-bold uppercase text-xs leading-tight mb-1 line-clamp-2" title={f.name}>
                {f.name}
              </div>
              {f.brand && <div className="text-[9px] text-muted uppercase tracking-widest truncate">{f.brand}</div>}
              <div className="text-[10px] text-[#FFD60A] mt-1 font-bold">
                {kcalHint} kcal <span className="text-muted font-normal">· {hintG}g</span>
              </div>
              {f.use_count > 1 && (
                <span className="absolute top-1 right-1 text-[9px] uppercase tracking-widest font-bold bg-[#FFD60A] text-black px-1.5 leading-tight">
                  ×{f.use_count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
